"use client"

import { ErrorBanner } from "@/components/ui/error-banner"
import { useCustomSearchParams } from "@/hooks/use-search-params"

const NoAutoLimitationBanner = () => {
  const [searchParams] = useCustomSearchParams()
  if (!(searchParams.get("errorBanner") === "noAutoLimitationSet")) return null
  return (
    <ErrorBanner
      body="NoAutoLimitationBanner.body"
      bodyValues={{
        a: (chunks) => (
          <a
            href={window.APP_MAIN_SITE_HOMEPAGE}
            target="_blank"
            rel="noopener noreferrer"
          >
            <strong>
              <u>{chunks}</u>
            </strong>
          </a>
        ),
      }}
    />
  )
}

export { NoAutoLimitationBanner }
